<ng-container *ngIf="formControl; else simpleCheckbox">
  <mat-checkbox [formControl]="formControl"
                [ngClass]="{'readonly': readonly}"
                (change)="onChange($event)">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </mat-checkbox>
  <app-form-error-list *ngIf="showErrors"
                       [errorMap]="formControl.errors">
  </app-form-error-list>
</ng-container>

<ng-template #simpleCheckbox>
  <mat-checkbox [checked]="checked"
                [disabled]="isDisabled"
                [ngClass]="{'readonly': readonly}"
                (change)="onChange($event)">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </mat-checkbox>
</ng-template>

<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>
